import React, { Fragment } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import clsx from 'clsx'
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Link,
  Radio,
  RadioGroup,
  Switch,
  useMediaQuery,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

import { Launch as LauchIcon } from '@material-ui/icons'

import useStyles from './styles'

import theme from 'theme'
import constants from 'constants/index'

const PositionCustomization = () => {
  const classes = useStyles()

  const { control, errors, watch } = useFormContext()

  const xlUp = useMediaQuery(theme.breakpoints.up('xl'), {
    defaultMatches: true,
  })

  const hideOnAccept = watch('hideOnAccept')
  const hideRejectButton = watch('hideRejectButton')

  return (
    <Fragment>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        width="100%"
      >
        <FormControl error={!!errors?.position}>
          <FormLabel className={classes.formLabel} color="primary">
            Defina o posicionamento do banner de cookies no seu site:
          </FormLabel>
          <Controller
            as={
              <RadioGroup>
                {constants.cookies.banner.CUSTOMIZATION_POSITION_RADIO_GROUP_ITEMS.map(
                  (item) => (
                    <Box key={item.value}>
                      <FormControlLabel
                        control={<Radio color="primary" />}
                        value={item.value}
                        label={item.label}
                      />
                    </Box>
                  ),
                )}
              </RadioGroup>
            }
            control={control}
            name="position"
            mode="onChange"
          />
          {!!errors?.position && (
            <FormHelperText error={!!errors?.position}>
              {<>{errors?.position?.message}</>}
            </FormHelperText>
          )}
        </FormControl>
        <Box mt={2}>
          <Controller
            name="hideOnAccept"
            control={control}
            as={
              <FormControl>
                <FormLabel className={classes.formLabel} color="primary">
                  Defina o comportamento de seu banner
                </FormLabel>
                <FormControlLabel
                  control={<Switch color="primary" checked={hideOnAccept} />}
                  label="Esconder banner ao aceitar"
                />
              </FormControl>
            }
            onChange={([event]) => event.target.checked}
          />
        </Box>
        <Alert severity="info" className={classes.alert}>
          Ao selecionar esta opção, o banner de cookies será reduzido para uma
          mensagem discreta assim que o usuário aceitar ou recusar os cookies.{' '}
          <strong>Atenção:</strong> será necessário adicionar um elemento HTML a
          mais em seu site.
          <Box display="flex" mt={1}>
            <Link
              href={constants.cookies.banner.LINK_DOCUMENTATION_HIDE_ON_ACCEPT}
              target="_blank"
            >
              Consulte a documentação
              <LauchIcon className={classes.icon} />
            </Link>
          </Box>
        </Alert>
        <Box mt={2}>
          <Controller
            name="hideRejectButton"
            control={control}
            as={
              <FormControl>
                <FormControlLabel
                  control={
                    <Switch color="primary" checked={hideRejectButton} />
                  }
                  label="Ocultar botão de rejeitar cookies"
                />
              </FormControl>
            }
            onChange={([event]) => event.target.checked}
          />
        </Box>
        <Alert
          severity="info"
          className={clsx(classes.alert, { [classes.alertBottom]: !xlUp })}
        >
          Recomendamos manter o botão de rejeitar visível no banner de cookies
          para garantir clareza na coleta de consentimento. Caso escolha
          ocultá-lo, o botão continuará disponível no gerenciador de cookies
          (segundo nível), preservando o direito de escolha do usuário.
        </Alert>
      </Box>
      {xlUp && <Divider orientation="vertical" variant="middle" />}
    </Fragment>
  )
}

export default PositionCustomization
